import type { ReactNode } from 'react';
import { COLORS } from 'styles/constants';
import { LiquidButton } from '../../../components/LiquidButton';
import type { FormObject } from '../../../types/EvalancheTypes';
import { ButtonFlexContainer, Container, StyledSubmitButton } from '../styles';

export const SubmitButton = ({
  form,
  formikProps,
}: {
  formikProps: any;
  form: FormObject;
}): ReactNode => (
  <Container>
    <ButtonFlexContainer>
      <StyledSubmitButton
        type="submit"
        value={form.translation?.submit}
        disabled={formikProps.isSubmitting}
        data-test={`submit-${form.translation?.submit}`}
      >
        <LiquidButton
          text={form.translation?.submit || 'Submit'}
          width={240}
          height={52}
          color={COLORS.primary}
          textColor={COLORS.white}
        />
      </StyledSubmitButton>
    </ButtonFlexContainer>
  </Container>
);
